export default __webpack_public_path__ + "static/bear-1-01f77bc6e05b7528322959f8f5734465.png";